import { isLocal, isProd, isStaging } from '@/lib/env';
import { cn } from '@/lib/cn';

export function EnvBadge() {
  if (isProd) return null;

  const label = isStaging ? 'STAGING' : 'LOCAL';
  const tone = isStaging
    ? 'bg-amber-500 text-white'
    : 'bg-blue-500 text-white';

  return (
    <div
      className={cn(
        'fixed top-2 right-2 z-50 rounded px-2 py-1 text-[10px] font-bold tracking-widest shadow-sm',
        tone,
      )}
      aria-hidden="true"
      title={`Environment: ${isLocal ? 'development (local)' : isStaging ? 'staging' : 'production'}`}
    >
      {label}
    </div>
  );
}
